<mat-toolbar class="header-container" >

    <div class=mat-icon-button (change)="handleAppBarMenuButton()" class="menu-container">
        <input class="checkbox" type="checkbox" id="checkbox-menu">
        <label class="label" for="checkbox-menu"> 
            <span class="underline"></span>
            <span class="underline"></span>
            <span class="underline"></span>
        </label>
    </div>

    <img 
        (click)="goToHomePage()"
        src="../../../../assets/images/logo/logo-hudlygo.png" 
        alt="HUDLY.Go" 
        class="logo"
    >

    <!--<div class="btn">
        <button  id="icon-notify">
            <mat-icon>notifications</mat-icon>
        </button>
        <button (click)="handleShowManual()" title="Acessar manual HUDLY.Go" mat-fab color="primary" class="action-fab">
            <mat-icon id="icon-question">question_mark</mat-icon>
        </button>
    </div>-->
    <div></div>
</mat-toolbar>



